import Clickable from '/components/Clickable';
import Image from '/components/Image';
import PropTypes from 'prop-types';

import classNames from '/utils/class-names';

import { getButtonImageSrc } from '/services/products';

const AvailableProducts = ({ activeProduct, availableProducts, setActiveProduct }) => {
	if (!availableProducts) {
		return null;
	}

	if (availableProducts.length === 0) {
		return <div>No products found.</div>;
	}

	return (
		<div className="flex flex-wrap my-2 md:my-4 justify-center gap-3 p-1">
			{availableProducts.map((product, productIndex) => {
				let buttonImageSrc = getButtonImageSrc(product);

				if (buttonImageSrc) {
					return (
						<div className="flex flex-col relative" key={productIndex}>
							<Clickable
								onClick={() => {
									setActiveProduct(product);
								}}
								className={classNames(
									'rounded-full h-[50px] w-[50px] m-px',
									activeProduct?.handle === product.handle
										? 'border-2 border-white ring-4 ring-gray-600 rounded-full hover:ring-gray-600'
										: 'hover:ring-gray-400 hover:border-2 border-white hover:ring-4',
								)}>
								<Image
									className="rounded-full"
									src={buttonImageSrc}
									height={200}
									width={200}
									objectFit="contain"
									alt="button image"
								/>
							</Clickable>
						</div>
					);
				}
			})}
		</div>
	);
};

AvailableProducts.propTypes = {
	activeProduct: PropTypes.object,
	availableProducts: PropTypes.array,
	setActiveProduct: PropTypes.func,
};

export default AvailableProducts;
